<template>
    <div class="recommendPageWarp">
        <div class="detail-newscontent" v-html="contentObj" v-if="contentObj"></div>
        <div v-else>
            <div class="emptyBox">
                <img src="@/assets/imgs/branchempty.jpg" />
            </div>
        </div>
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
    data() {
        return {
            dataList: [],
            currentPage: 1,
            pageSize: 10,
            contentObj: null
        }
    },
    mounted() {
        this.getNewsData()
    },
    methods: {
        async getNewsData() {
            let params = {
                pageSize: this.pageSize,
                pageCurrent: this.currentPage,
                pressSuperClass: 69,
                // branchRegion: 3,
            };
            let data = await httpService.getHeadList(params);
            if (data.code == 200) {
                if (data.result.list.length != 0) {
                    this.contentObj = data.result.list[0]
                }
            }
        },

    }
}
</script>
<style lang="less" scoped>
.recommendPageWarp {
	width: 100%;
    .emptyBox {
		img {
			width: 198px;
			height: 200px;
		}
	}
}
</style>


